module.exports = __webpack_public_path__ + "img/img-relay-step1.9da74e2e.svg";